module.exports = __webpack_public_path__ + "assets/img/map.b4676bbb.png";